import { gql } from '@apollo/client'

const ORDER_LINE_ITEM_NODE = gql`
  fragment OrderLineItemNode on Order {
    lineItems {
      id
      price
      title
      imageUrl
      itemUrl
      downloadUrl
      orderLineNumber
      orderNumber
      type
      autoRenew
    }
  }
`

export const ORDER_NODE = gql`
  fragment OrderNode on Order {
    id
    date
    totalPrice
    shippedTo
    orderNumber
    receiptUrl
    ...OrderLineItemNode
  }
  ${ORDER_LINE_ITEM_NODE}
`
